import React from "react";
import { Fade } from "react-awesome-reveal";
import "./SingleService.css";
import { connect } from "react-redux";

type ISingleServiceProps = Partial<ReturnType<typeof mapStateToProps>> & {
  id;
  title;
  icon;
};

function SingleService(props: ISingleServiceProps) {
  const { theme, id, title, icon } = props;
  return (
    <Fade direction="up" triggerOnce>
      <div
        key={id}
        className="single-service"
        style={{ backgroundColor: "#ffffff" }}
      >
        <div className="service-content" style={{ color: theme.primary }}>
          <i className="service-icon">{icon}</i>
          <h4 style={{ color: theme.tertiary }}>{title}</h4>
        </div>
      </div>
    </Fade>
  );
}

const mapStateToProps = (state) => ({
  theme: state.rootState.theme,
});

export default connect(mapStateToProps)(SingleService);
